var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.linkSetFilter.length
    ? _c("tr", [
        _c(
          "th",
          { staticStyle: { "border-bottom": "0" } },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _c(
          "td",
          { staticStyle: { "border-bottom": "0" } },
          _vm._l(_vm.linkSetFilter, function(linkset, index) {
            return _c("div", { key: index }, [
              _c("span", [_vm._v(_vm._s(_vm.getLinksetTitle(linkset.key)))]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(linkset.data, function(link, linkIndex) {
                  return _c(
                    "li",
                    { key: linkIndex },
                    [
                      _c("a", { attrs: { href: link.href } }, [
                        _vm._v(_vm._s(link.title))
                      ]),
                      _vm._v(" "),
                      _vm._l(link.hreflang, function(lang, langIndex) {
                        return _c(
                          "span",
                          { key: langIndex },
                          [_c("lang-string", { attrs: { lang: lang } })],
                          1
                        )
                      })
                    ],
                    2
                  )
                })
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-bottom": "5px" } })
            ])
          })
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-122f9e97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122f9e97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinksTr.vue
// module id = null
// module chunks = 